import React from "react"
import { useSelector } from "react-redux"
import { FieldArray } from "formik"

import { getSettings } from "@/onboarding/features/product/selectors"

import InputList from "./InputList"

const TextList = ({
  name,
  label,
  readOnly = false,
  showLockedIcon = false,
  showRequired = false,
}) => {
  const field = useSelector(getSettings(name))
  const editable = field[name]?.writeable === true

  return (
    <FieldArray
      name={name}
      render={(arrayHelpers) => (
        <InputList
          name={name}
          label={label}
          push={arrayHelpers.push}
          remove={arrayHelpers.remove}
          readOnly={!editable && readOnly}
          showControls={editable}
          showLockedIcon={showLockedIcon}
          showRequired={showRequired}
        />
      )}
    />
  )
}

export default TextList
